<ng-container *ngIf="label">
  <div class="capsule" [class.small]="small" [class.inline]="inline" [style.background-color]="backgroundColor">
      <div class="swatch" *ngIf="swatchColor" [style.background-color]="swatchColor"></div>
      {{ label }}
  </div>
</ng-container>
